;((win, doc, $) => {
  'use strict';
  if (!$) { return; }

  const ua = require('_shared_class/ua');

  let html_class = 'is-js';

  if(ua.isSP) {
    html_class += ' is-sp';
  }else {
    html_class += ' is-pc';
  }

  if(ua.isAndroid) {
    html_class += ' is-android';
  }

  if(ua.isIOS) {
    html_class += ' is-ios';
  }

  $('html').addClass(html_class);

  $(() => {
    $('.page-kamu a[href^="#"]').on('click', function(e) {
      let elem = $(this);
      let href = elem.attr('href');
      let target = $(href);

      if(!target.length) { return; }

      e.preventDefault();
      $('html,body').animate({ scrollTop: target.offset().top }, 500, 'swing');

    })
  });


})(window, document, window['jQuery']);



// WEBPACK FOOTER //
// ../_mrk_src/js/common.js